import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../../_helpers/Helpers";
import * as actions from "../../../../../_redux/private-notices/PrivateNoticesAction";
import { useStudentsUIContext } from "../StudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { name, surname, sectionId, phone, email } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, surname, sectionId, phone, email };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StudentsFilter() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      setQueryParams: studentsUIContext.setQueryParams,
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);

  const dispatch = useDispatch();
  const { sections } = useSelector(
    (state) => ({
      sections: state.privateNotices.filterList
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getSections());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const sectionOptions = FilterOptions.concat(sections);

  return (
    <Formik
      initialValues={{        
        name: "",
        surname: "",
        phone: "",
        email: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Şube"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="phone"
                placeholder="Telefon"
                onBlur={handleBlur}
                value={values.phone}
                onChange={(e) => {
                  setFieldValue("phone", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Telefon</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="email"
                placeholder="Email"
                onBlur={handleBlur}
                value={values.email}
                onChange={(e) => {
                  setFieldValue("email", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Email</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}